import React, { useEffect, useState } from "react";
import { Image, Row, Col, Table, Form } from "react-bootstrap";
function MainFilterSection()  {
    
    const [search, setSearch] = useState("");
    const [isActive, setActive] = useState(false);

    const [state,setState] = useState({
      temp:"",
    })
    return (
        <>
        <div className="d-flex w-50">
        <div className={`newexpandablesearch mt-2 mr-2  ${isActive ? "active" : null}`}>
                <div className="searchicon">
                  <i 
                   onClick={() => { setActive(!isActive); setSearch(''); }} 
                  className="fa fa-search" aria-hidden="true" style={{ fontSize: "20px" }}></i>
                </div>
                <div className="input">
                  <Form.Control
                    type="text"
                    placeholder="Experience Name,ID, venue."
                    className="newsearchinput"
                    value={search}
                    onChange={(e) => { setSearch(e.target.value); }}
                    style={{ borderRadius: "28px" }}
                  />
                  <i className="fa fa-timesw" aria-hidden="true"></i>
                </div>
        </div>
        <div
                      className="f10-400"
                      align="center"
                    //  onClick={() => showFilter(!filter)}
                    >
                      <img
                        src={require("../../../assets/images/iconButton/filterbtn.svg")}
                        width="80px"
                      />
                    </div>
                    <div
                          className="f10-400"
                          align="center"
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                        //  onClick={handleClick}
                        >
                          <img
                            src={require("../../../assets/images/iconButton/sortbtn.svg")}
                            width="80px"
                          />
                        </div>
                        <div className="f10-400" align="center">
          <img
            src={require("../../../assets/images/iconButton/downloadbtn.svg")}
            width="80px"
            alt="icon"
            title="Download"
          />
        </div>
        </div>
        </>
    )

};
export default MainFilterSection;